/**
 * Created by r4zi4l on 04.05.2022
 */

const Offers = { 
    TYPES: {}
};

Offers.TYPES.LIVESFEAST = 1;
Offers.TYPES.SOFTFEAST = 2;
Offers.TYPES.KRAKENFEAST = 3;
Offers.TYPES.BUILDPASS = 4;
Offers.TYPES.SALEPASS = 5;
Offers.TYPES.EXPEDITION = 6;
Offers.TYPES.UNDERSEA = 7;
Offers.TYPES.UNDERSEA2 = 8;
Offers.TYPES.SNAILFEAST_UNDERSEA2 = 9;
Offers.TYPES.HALLOWEEN = 10;
Offers.TYPES.SNAILFEAST = 11;
Offers.TYPES.RAPUNZEL = 12;
Offers.TYPES.XMAS = 13;
Offers.TYPES.RAPUNZEL2 = 14;

Offers.TYPES.EASTER = 16;
Offers.TYPES.DRAGONIA2 = 17;
Offers.TYPES.DRAGONIA3 = 18;
Offers.TYPES.SNAILFEAST_DRAGONIA3 = 19;
Offers.TYPES.CHINA = 20;
Offers.TYPES.CHAIN_SALE = 21;
Offers.TYPES.SUPPLIES_SALE = 22;
Offers.TYPES.PROMOTION_SALE = 23;
Offers.TYPES.RAPUNZEL3 = 24;
Offers.TYPES.CLCHAIN_SALE = 25;
Offers.TYPES.CLSUPPLIES_SALE = 26;
Offers.TYPES.CLPROMOTION_SALE = 27;
Offers.TYPES.PACK = 28;
Offers.TYPES.PIXEL_OFFER = 29;
Offers.TYPES.CLPASS = 31;
Offers.TYPES.STICKERS_PACK = 32;
Offers.TYPES.SNAILFEAST_UNDERSEA3 = 33;
Offers.TYPES.UNDERSEA3 = 34;
Offers.TYPES.PINBALL_PACK = 35;
Offers.TYPES.SNAILFEAST_HALLOWEEN = 36;
Offers.TYPES.BLACKFRIDAY = 37;
Offers.TYPES.SNAILFEAST_BLACKFRIDAY = 38;
Offers.TYPES.BOOSTER_OFFER = 39;
Offers.TYPES.SNAILFEAST_XMAS = 40;
Offers.TYPES.SNAILFEAST_CHINA = 41;
Offers.TYPES.SPRING = 42;
Offers.TYPES.SNAILFEAST_SPRING = 43;

Offers.TYPES.JULY4 = 45;
Offers.TYPES.SUMMERPETS = 46;
Offers.TYPES.LABORDAY = 47;
Offers.TYPES.STARTALE = 48;
Offers.TYPES.CHARACTER_OFFER = 49;
Offers.TYPES.KINGSCUP = 50;
Offers.TYPES.BOOST_TIME_OFFER = 51;
Offers.TYPES.NEW_CHARACTER_OFFER = 52;

Offers.TYPES.TSEARCHPACK = 53;
Offers.TYPES.SPACERACEPACK = 54;

Offers.TYPES.LINE_OFFER = 55;
Offers.TYPES.ENERGY_START_OFFER = 56;
Offers.TYPES.ENERGY_EXTENSION_OFFER = 57;

Offers.TYPES.SNAILFEAST_STARTALE = 58;

Offers.TYPES.ADVENTURENY_CHEAP_OFFER = 66;
Offers.TYPES.ADVENTURENY_EXP_OFFER = 67;
Offers.TYPES.ADVENTURE4_CHEAP_OFFER = 68;
Offers.TYPES.ADVENTURE4_EXP_OFFER = 69;
Offers.TYPES.ADVENTUREVD_CHEAP_OFFER = 70;
Offers.TYPES.ADVENTUREVD_EXP_OFFER = 71;

// Offers.TYPES.CHINA26 = 72; unused
Offers.TYPES.SNAILFEAST_CHINA26 = 73;

Offers.TYPES.ISLAND_DECORATION_OFFER = 93;

Offers.TYPES.PATRICKDAY_CHEAP_OFFER = 90;
Offers.TYPES.PATRICKDAY_EXP_OFFER = 91;

Offers.TYPES.EASTER26 = 92;
Offers.TYPES.TESTADV_CHEAP_OFFER = 94;
Offers.TYPES.TESTADV_EXP_OFFER = 95;
Offers.TYPES.EASTER26_ONCEPERLOCATION = 96;
Offers.TYPES.EARTHDAY_CHEAP_OFFER = 97;
Offers.TYPES.EARTHDAY_EXP_OFFER = 98;
Offers.TYPES.SPRING26 = 99;
Offers.TYPES.SNAILFEAST_SPRING26 = 100;

Offers.TYPES.ENERGY_KIT = 101;
Offers.TYPES.NIGHTPARTY_CHEAP_OFFER = 102;
Offers.TYPES.NIGHTPARTY_EXP_OFFER = 103;
Offers.TYPES.GRADUATION = 104;
Offers.TYPES.NEW_STARTER_PACK = 105;
Offers.TYPES.GENERATOR_OFFER_AB = 106;
Offers.TYPES.GENERATOR_OFFER_CD = 107;
Offers.TYPES.GENERATOR_OFFER_E = 108;
Offers.TYPES.GENERATOR_OFFER_Z = 109;
Offers.TYPES.GENERATOR_OFFER_F = 110;
Offers.TYPES.GENERATOR_OFFER_GH = 111;
Offers.TYPES.GENERATOR_OFFER_I = 112;
Offers.TYPES.GENERATOR_OFFER_O = 113;
Offers.TYPES.HIGH_STAGE_A = 114;
Offers.TYPES.HIGH_STAGE_E = 115;
Offers.TYPES.HIGH_STAGE_G = 116;
Offers.TYPES.HIGH_STAGE_I = 117;
Offers.TYPES.HIGH_STAGE_C = 118;

Offers.TYPES.NIGHTPARTY_TEST_CHEAP_OFFER = 119;
Offers.TYPES.NIGHTPARTY_TEST_EXP_OFFER = 120;

Offers.TYPES.GRADUATION_EXP_PACK_OFFER = 121;
Offers.TYPES.GRADUATION_LINE_OFFER = 122;
Offers.TYPES.GRADUATION_HERO_OFFER = 123;
Offers.TYPES.MUSICFEST = 124;
Offers.TYPES.SNAILFEAST_MUSICFEST = 125;
Offers.TYPES.PIRATES_CHEAP_OFFER = 126;
Offers.TYPES.PIRATES_EXP_OFFER = 127;

Offers.TYPES.MUSICFEST_EXP = 128;
Offers.TYPES.MUSICFEST_LINE = 129;
Offers.TYPES.MUSICFEST_HERO = 130;

Offers.TYPES.CANDY_PACK = 131;
Offers.TYPES.CANDY_PACK_ALTERNATIVE = 132;

Offers.TYPES.CANDY_LINE_OFFER = 133;
Offers.TYPES.CANDY_LINE_OFFER_ALTERNATIVE = 134;

Offers.TYPES.CANDY_HERO_OFFER = 135;
Offers.TYPES.CANDY_HERO_OFFER_ALTERNATIVE = 136;
Offers.TYPES.LABORDAY26_CHEAP_OFFER = 137;
Offers.TYPES.LABORDAY26_EXP_OFFER = 138;
Offers.TYPES.AUTUMN26 = 139;
Offers.TYPES.SNAILFEAST_AUTUMN26 = 140;

Offers.TYPES.LEVEL_MASTERY_PACK = 141;
Offers.TYPES.HUNGRY_GAMES_PACK = 142;
Offers.TYPES.LIGHTNING_RUSH_PACK = 143;
Offers.TYPES.LORIES_DERBY_PACK = 144;
Offers.TYPES.SEPTEMBER_OFFER = 145;
Offers.TYPES.OCTOBER_OFFER = 146;
Offers.TYPES.NOVEMBER11_OFFER = 147;
Offers.TYPES.NOVEMBER_FRIDAY_OFFER = 148;
Offers.TYPES.DECEMBER_OFFER = 149;
Offers.TYPES.JANUARY_OFFER = 150;
Offers.TYPES.FEBRUARY_OFFER = 151;

Offers.TYPES.AUTUMN26_HERO_OFFER = 155;
Offers.TYPES.AUTUMN26_LINE_OFFER = 156;

// 153, 154, 158-161: expedition offers, their ids are in expedition/<id>/design/offers.json (the build fails on a clash)
Offers.TYPES.NOADS = 162;
// 163 and 164 - gnome26 expedition offers
Offers.TYPES.ONEPLUSONE = 165;
// 166-169 - xmas26 expedition offers

Offers.SEASONAL = ["september", "october", "november11", "november_friday", "december", "january", "february"];

Offers.defineSeasonal = function (products, icon) {
    Offers.SEASONAL.forEach((id) => {
        const feature = `${id}_offer`;
        const type = feature.toUpperCase();
        const name = `${id.split("_").map((part) => part[0].toUpperCase() + part.slice(1)).join("")}Offer`;
        const shown = icon(feature);
        if (!shown) {
            return;
        }

        Offers[Offers.TYPES[type]] = {
            productByPayerLevel: products,
            rewardByPayerLevel: RewardsConfig[name],
            ...shown,
            view: OfferWindow,
            bundle: `offer_${id}`,
            name,
            feature,
            cooldown: "24 hours",
            pendingWindow: true,
            available: cleverapps.config.availables[type]
        };
    });
};

Offers.initialize = function () {
    if (cleverapps.config.features.includes("noads")) {
        Offers[Offers.TYPES.NOADS] = {
            name: "NoAds",
            product: "noAds",
            logic: NoAdsOfferLogic,
            view: NoAdsWindow,
            bundle: "noads_window",
            sideBarJson: bundles.sidebar.jsons.noads_icon_json,
            extraBarIcon: bundles.extrabar && bundles.extrabar.jsons.noads_extrabar_icon && {
                json: bundles.extrabar.jsons.noads_extrabar_icon,
                background: bundles.extrabar.frames.extrabar_icon_bg_blue
            },
            isAvailable: () => cleverapps.noAds.canBuy(),
            anyLocation: true,
            tileShopPriority: 0
        };
    }

    if (cleverapps.config.features.includes("starter_pack")) {
        Offers[Offers.TYPES.PACK] = {
            name: "Pack",
            cooldown: "1 day",
            logic: PackOfferLogic,
            bundle: "starter_pack",
            sideBarJson: [bundles.sidebar.jsons.pack_icon_json, bundles.sidebar.jsons.pack1_icon_json, bundles.sidebar.jsons.pack2_icon_json],
            extraBarIcon: bundles.extrabar && [{
                json: bundles.extrabar.jsons.pack_extrabar_icon,
                background: bundles.extrabar.frames.extrabar_icon_bg_blue
            }, {
                json: bundles.extrabar.jsons.pack1_extrabar_icon,
                background: bundles.extrabar.frames.extrabar_icon_bg_blue
            }, {
                json: bundles.extrabar.jsons.pack2_extrabar_icon,
                background: bundles.extrabar.frames.extrabar_icon_bg_blue
            }],
            view: PackWindow,
            pendingWindow: true,
            productByStage: ["starterPack0", "starterPack", "starterPack2"],
            availableByStages: [
                cleverapps.config.availables.STARTER_PACK0,
                cleverapps.config.availables.STARTER_PACK,
                cleverapps.config.availables.STARTER_PACK2
            ]
        };
    }

    if (cleverapps.config.features.includes("chainsale")) {
        Offers[Offers.TYPES.CHAIN_SALE] = {
            available: cleverapps.config.availables.CHAIN_SALE_OFFER,
            name: "ChainSale",
            duration: "3 day",
            cooldown: "14 days",
            logic: ChainSaleLogic,
            bundle: "chain_sale",
            sideBarJson: bundles.sidebar.jsons.chain_sale_json,
            extraBarIcon: bundles.extrabar && {
                json: bundles.extrabar.jsons.chain_sale_extrabar_icon,
                background: bundles.extrabar.frames.extrabar_icon_bg_green
            },
            view: ChainSaleWindow,
            pendingWindow: true
        };
    }

    if (cleverapps.config.features.includes("offers") && cleverapps.config.features.includes("hungry_games")) {
        Offers[Offers.TYPES.HUNGRY_GAMES_PACK] = {
            mission: Mission.TYPE_HUNGRY_GAMES,
            sideBarJson: bundles.sidebar.jsons.hungry_games_pack_json,
            productByPayerLevel: ["kit1", "kit3", "kit5", "kit10", "kit20"],
            name: "HungryGamesPack",
            duration: "3 days",
            oncePerMission: true,
            debugMode: true,
            view: OfferWindow,
            bundle: "offer_5",
            rewardByPayerLevel: RewardsConfig.HungryGamesPack,
            pendingWindow: true,
            extraBarIcon: bundles.extrabar && bundles.extrabar.jsons.hungry_games_offer_extrabar_icon && {
                json: bundles.extrabar.jsons.hungry_games_offer_extrabar_icon,
                background: bundles.extrabar.frames.extrabar_icon_bg_blue
            }
        };
    }

    if (cleverapps.config.features.includes("suppliessale")) {
        Offers[Offers.TYPES.SUPPLIES_SALE] = {
            available: cleverapps.config.availables.SUPPLIES_SALE_OFFER,
            name: "SuppliesSale",
            cooldown: "30 days",
            logic: SuppliesSaleLogic,
            sideBarJson: bundles.sidebar.jsons.supplies_icon_json,
            extraBarIcon: bundles.extrabar && {
                json: bundles.extrabar.jsons.supplies_extrabar_icon,
                background: bundles.extrabar.frames.extrabar_icon_bg_blue
            },
            view: SuppliesWindow,
            pendingWindow: true
        };
    }

    if (cleverapps.config.features.includes("promotionsale")) {
        Offers[Offers.TYPES.PROMOTION_SALE] = {
            available: cleverapps.config.availables.PROMOTION_SALE_OFFER,
            name: "PromotionSale",
            duration: "3 day",
            cooldown: "14 days",
            logic: PromotionSaleLogic,
            bundle: "promotion_sale",
            sideBarJson: bundles.sidebar.jsons.promotion_sale_json,
            extraBarIcon: bundles.extrabar && {
                json: bundles.extrabar.jsons.promotion_sale_extrabar_icon,
                background: bundles.extrabar.frames.extrabar_icon_bg_orange
            },
            view: PromotionSaleWindow,
            pendingWindow: true
        };
    }

    if (cleverapps.config.features.includes("oneplusoneoffer")) {
        Offers[Offers.TYPES.ONEPLUSONE] = {
            name: "OnePlusOne",
            product: "kit5",
            reward: RewardsConfig.OnePlusOnePaid,
            freeReward: RewardsConfig.OnePlusOneFree,
            duration: "2 days",
            afterEvent: "MERGE2_MISSION_OFFER_DAY",
            pendingWindow: true,
            logic: OnePlusOneOfferLogic,
            view: OnePlusOneOfferWindow,
            bundle: "oneplusone_offer",
            sideBarJson: bundles.sidebar.jsons.oneplusone_offer_json
        };
    }

    if (cleverapps.config.type === "merge") {
        if (cleverapps.config.features.includes("offers")) {
            Offers[Offers.TYPES.CHARACTER_OFFER] = {
                productByPayerLevel: ["kit1", "kit3", "kit3", "kit10", "kit10"],
                rewardByPayerLevel: RewardsConfig.CharacterOffer,
                extraBarIcon: bundles.extrabar && {
                    json: bundles.extrabar.jsons.character_offer_extrabar_icon,
                    background: bundles.extrabar.frames.extrabar_icon_bg_green
                },
                view: OfferWindow,
                bundle: "offer_0",
                name: "CharacterOffer",
                duration: "25 hours",
                cooldown: "24 hours",
                afterEvent: "ONE_OF_TWO_LAST_HERO_ITEMS_SPAWNED",
                pendingWindow: true,
                available: cleverapps.config.availables.CHARACTER_OFFER
            };

            if (cleverapps.config.features.includes("boosttime")) {
                Offers[Offers.TYPES.BOOST_TIME_OFFER] = {
                    mission: Mission.TYPE_BOOSTTIME,
                    productByPayerLevel: ["kit3", "kit10", "kit10", "kit50", "kit50"],
                    rewardByPayerLevel: RewardsConfig.BoostTimeOffer,
                    extraBarIcon: bundles.extrabar && {
                        json: bundles.extrabar.jsons.boost_time_offer_extrabar_icon,
                        background: bundles.extrabar.frames.extrabar_icon_bg_green
                    },
                    view: OfferWindow,
                    bundle: "offer_1",
                    name: "BoostTimeOffer",
                    duration: "8 hours",
                    cooldown: "24 hours",
                    pendingWindow: true,
                    available: cleverapps.config.availables.BOOST_TIME_OFFER
                };
            }

            Offers[Offers.TYPES.NEW_CHARACTER_OFFER] = {
                productByPayerLevel: ["kit3", "kit10", "kit10", "kit50", "kit50"],
                rewardByPayerLevel: RewardsConfig.NewCharacterOffer,
                extraBarIcon: bundles.extrabar && {
                    json: bundles.extrabar.jsons.new_character_offer_extrabar_icon,
                    background: bundles.extrabar.frames.extrabar_icon_bg_green
                },
                view: OfferWindow,
                bundle: "offer_2",
                name: "NewCharacterOffer",
                duration: "570 minutes",
                cooldown: "24 hours",
                afterEvent: "FIRST_HERO_ITEM_SPAWNED",
                pendingWindow: true,
                available: cleverapps.config.availables.NEW_CHARACTER_OFFER
            };

            Offers[Offers.TYPES.LINE_OFFER] = {
                productByPayerLevel: ["kit1", "kit3", "kit3", "kit10", "kit10"],
                rewardByPayerLevel: RewardsConfig.LineOffer,
                extraBarIcon: bundles.extrabar && {
                    json: bundles.extrabar.jsons.line_offer_extrabar_icon,
                    background: bundles.extrabar.frames.extrabar_icon_bg_green
                },
                view: OfferWindow,
                bundle: "offer_3",
                name: "LineOffer",
                duration: "24 hours",
                cooldown: "24 hours",
                afterEvent: "ONE_OF_TWO_LAST_UNIT_STAGES_SPAWNED",
                pendingWindow: true,
                available: cleverapps.config.availables.LINE_OFFER
            };

            Offers[Offers.TYPES.ENERGY_START_OFFER] = {
                productByPayerLevel: ["kit1", "kit3", "kit3", "kit10", "kit10"],
                rewardByPayerLevel: RewardsConfig.EnergyStart,
                extraBarIcon: bundles.extrabar && {
                    json: bundles.extrabar.jsons.energy_start_offer_extrabar_icon,
                    background: bundles.extrabar.frames.extrabar_icon_bg_green
                },
                view: OfferWindow,
                bundle: "offer_4",
                name: "EnergyStart",
                duration: "72 hours",
                cooldown: "30 days",
                afterEvent: "ENERGY_VERY_LOW",
                oneOf: [Offers.TYPES.ENERGY_START_OFFER, Offers.TYPES.ENERGY_EXTENSION_OFFER],
                pendingWindow: true,
                available: cleverapps.config.availables.ENERGY_START_OFFER
            };

            Offers[Offers.TYPES.ENERGY_EXTENSION_OFFER] = {
                productByPayerLevel: ["kit3", "kit10", "kit10", "kit50", "kit50"],
                rewardByPayerLevel: RewardsConfig.EnergyExtension,
                extraBarIcon: bundles.extrabar && {
                    json: bundles.extrabar.jsons.energy_start_offer_extrabar_icon,
                    background: bundles.extrabar.frames.extrabar_icon_bg_green
                },
                view: OfferWindow,
                bundle: "offer_5",
                name: "EnergyExtension",
                duration: "48 hours",
                cooldown: "30 days",
                afterEvent: "ENERGY_VERY_LOW",
                oneOf: [Offers.TYPES.ENERGY_START_OFFER, Offers.TYPES.ENERGY_EXTENSION_OFFER],
                pendingWindow: true,
                available: cleverapps.config.availables.ENERGY_EXTENSION_OFFER
            };

            if (cleverapps.config.features.includes("island_decoration")) {
                Offers[Offers.TYPES.ISLAND_DECORATION_OFFER] = {
                    mission: Mission.TYPE_ISLAND_DECORATION,
                    productByPayerLevel: ["kit3", "kit10", "kit10", "kit50", "kit50"],
                    rewardByPayerLevel: RewardsConfig.LTDOffer,
                    extraBarIcon: bundles.extrabar && {
                        json: bundles.extrabar.jsons.ltd_offer_extrabar_icon,
                        background: bundles.extrabar.frames.extrabar_icon_bg_green
                    },
                    view: OfferWindow,
                    bundle: "offer_9",
                    name: "IslandDecorationOffer",
                    duration: "24 hours",
                    cooldown: "3 days",
                    pendingWindow: true,
                    available: cleverapps.config.availables.ISLAND_DECORATION_OFFER
                };
            }

            Offers.defineSeasonal(["kit3", "kit3", "kit10", "kit10", "kit50"], (feature) => ({
                extraBarIcon: bundles.extrabar && {
                    json: bundles.extrabar.jsons[`${feature}_extrabar_icon`],
                    background: bundles.extrabar.frames.extrabar_icon_bg_green
                }
            }));
        }

        if (cleverapps.config.features.includes("livesfeast")) {
            Offers[Offers.TYPES.LIVESFEAST] = {
                mission: Mission.TYPE_LIVESFEAST,
                price: 250,
                view: SingleProductOfferPrefabWindow,
                reward: RewardsConfig.LivesFeast.offer,
                extraBarIcon: bundles.extrabar && {
                    json: bundles.extrabar.jsons.lives_feast_offer_extrabar_icon,
                    background: bundles.extrabar.frames.extrabar_icon_bg_purple
                },
                name: "LivesFeast",
                bundle: "lives_offer"
            };
        }

        if (cleverapps.config.features.includes("buildpass")) {
            Offers[Offers.TYPES.BUILDPASS] = {
                mission: Mission.TYPE_BUILDPASS,
                price: 299,
                reward: RewardsConfig.BuildPass.offer,
                view: SingleProductOfferWindow,
                sideBarJson: bundles.sidebar.jsons.buildpass_offer,
                extraBarIcon: bundles.extrabar && {
                    json: bundles.extrabar.jsons.buildpass_offer_extrabar_icon,
                    background: bundles.extrabar.frames.extrabar_icon_bg_blue
                },
                name: "BuildPass",
                bundle: "buildpass_offer"
            };
        }

        if (cleverapps.config.features.includes("salepass")) {
            Offers[Offers.TYPES.SALEPASS] = {
                mission: Mission.TYPE_SALEPASS,
                price: 299,
                reward: RewardsConfig.SalePass.offer,
                view: SingleProductOfferWindow,
                sideBarJson: bundles.sidebar.jsons.salepass_offer,
                extraBarIcon: bundles.extrabar && {
                    json: bundles.extrabar.jsons.salepass_offer_extrabar_icon,
                    background: bundles.extrabar.frames.extrabar_icon_bg_orange
                },
                name: "SalePass",
                bundle: "salepass_offer"
            };
        }

        if (cleverapps.config.features.includes("softfeast") && ["mbga", "sp_mbga"].indexOf(connector.info.source) === -1) {
            Offers[Offers.TYPES.SOFTFEAST] = {
                mission: Mission.TYPE_SOFTFEAST,
                price: 250,
                reward: RewardsConfig.SoftFeast.offer,
                view: SingleProductOfferPrefabWindow,
                sideBarJson: bundles.sidebar.jsons.soft_feast_offer,
                extraBarIcon: bundles.extrabar && {
                    json: bundles.extrabar.jsons.soft_feast_offer_extrabar_icon,
                    background: bundles.extrabar.frames.extrabar_icon_bg_purple
                },
                name: "SoftFeast",
                bundle: "soft_offer"
            };
        }

        if (cleverapps.config.features.includes("krakenfeast")) {
            Offers[Offers.TYPES.KRAKENFEAST] = {
                mission: Mission.TYPE_KRAKENFEAST,
                reward: RewardsConfig.KrakenFeast.offer,
                price: 299,
                view: SingleProductOfferPrefabWindow,
                extraBarIcon: bundles.extrabar && {
                    json: bundles.extrabar.jsons.kraken_offer_extrabar_icon,
                    background: bundles.extrabar.frames.extrabar_icon_bg_green
                },
                name: "KrakenFeast",
                bundle: "kraken_offer"
            };
        }

        Offers[Offers.TYPES.EXPEDITION] = {
            location: "dragonia",
            hero: { code: "dragonpack", stage: 0 },
            product: "expeditionPack",
            force: Forces.OFFER_ICON_SLOT2,
            fog: "fog4",
            reward: RewardsConfig.DragoniaPack,
            view: SingleProductOfferWindow,
            extraBarIcon: bundles.extrabar && {
                json: bundles.extrabar.jsons.dragonia_offer_extrabar_icon,
                background: bundles.extrabar.frames.extrabar_icon_bg_orange
            },
            name: "DragoniaPack",
            bundle: "dragonia_offer"
        };

        if (cleverapps.config.features.includes("snailfeast")) {
            Offers[Offers.TYPES.SNAILFEAST] = {
                mission: Mission.CompoundType(Mission.TYPE_SNAIL_FEAST, "dragonia2"),
                price: 99,
                view: SingleProductOfferWindow,
                extraBarIcon: function () {
                    return bundles.extrabar && {
                        json: cleverapps.skins.getSlot("snailhouse_offer_extrabar_icon"),
                        background: bundles.extrabar.frames.extrabar_icon_bg_orange
                    };
                },
                reward: RewardsConfig.SnailHouseDragoniaPack,
                name: "SnailPack",
                bundle: "snailhouse_offer"
            };
        }

        if (cleverapps.config.features.includes("pixel_offer")) {
            Offers[Offers.TYPES.PIXEL_OFFER] = {
                available: cleverapps.config.availables.PIXEL_OFFER,
                name: "PixelOffer",
                duration: "2 hours",
                cooldown: "12 hours",
                logic: PixelOfferLogic,
                sideBarJson: bundles.sidebar.jsons.pixel_offer_icon_json,
                extraBarIcon: bundles.extrabar && {
                    json: bundles.extrabar.jsons.pixel_offer_extrabar_icon,
                    background: bundles.extrabar.frames.extrabar_icon_bg_blue
                },
                view: PixelOfferWindow,
                availableByStages: [{}, {}, {}, {}, {}, {}]
            };
        }

        if (cleverapps.config.features.includes("collectionspass")) {
            Offers[Offers.TYPES.CLPASS] = {
                mission: Mission.TYPE_COLLECTIONS_PASS,
                price: 999,
                view: SingleProductOfferWindow,
                reward: RewardsConfig.CollectionsPass.offer,
                sideBarJson: bundles.sidebar.jsons.collections_pass_offer,
                extraBarIcon: bundles.extrabar && {
                    json: bundles.extrabar.jsons.collections_pass_offer_extrabar_icon,
                    background: bundles.extrabar.frames.extrabar_icon_bg_green
                },
                name: "CollectionsPass",
                bundle: "clpass_offer",
                location: "collections",
                cooldown: "48 hours"
            };
        }

        if (cleverapps.config.features.includes("chainsale")) {
            Offers[Offers.TYPES.CLCHAIN_SALE] = {
                ...Offers[Offers.TYPES.CHAIN_SALE],
                name: "ClChainSale",
                reward: RewardsConfig.ClChainSale,
                location: "collections",
                available: cleverapps.config.availables.CLCHAIN_SALE_OFFER
            };
        }
        if (cleverapps.config.features.includes("suppliessale")) {
            Offers[Offers.TYPES.CLSUPPLIES_SALE] = {
                ...Offers[Offers.TYPES.SUPPLIES_SALE],
                name: "ClSuppliesSale",
                reward: RewardsConfig.ClSupplies.rewards,
                location: "collections",
                available: cleverapps.config.availables.CLSUPPLIES_SALE_OFFER
            };
        }
        if (cleverapps.config.features.includes("promotionsale")) {
            Offers[Offers.TYPES.CLPROMOTION_SALE] = {
                ...Offers[Offers.TYPES.PROMOTION_SALE],
                name: "ClPromotionSale",
                reward: RewardsConfig.ClPromotionSale,
                location: "collections",
                available: cleverapps.config.availables.CLPROMOTION_SALE_OFFER
            };
        }

        if (cleverapps.config.features.includes("kingscup")) {
            Offers[Offers.TYPES.KINGSCUP] = {
                mission: Mission.TYPE_KINGSCUP,
                price: 250,
                view: SingleProductOfferWindow,
                reward: RewardsConfig.KingsCupOffer,
                extraBarIcon: bundles.extrabar && {
                    json: bundles.extrabar.jsons.lives_feast_offer_extrabar_icon,
                    background: bundles.extrabar.frames.extrabar_icon_bg_purple
                },
                name: "KingsCup",
                bundle: "kingscup_offer"
            };
        }

        Meta.REGISTER_OFFERS_PER_LOCATION();
    } else if (cleverapps.config.locations) {
        LocationConfigResolver.registerOffers(LocationConfigResolver.resolveLocationsList(cleverapps.config.locations));
    }

    if (cleverapps.config.features.includes("pinball")) {
        Offers[Offers.TYPES.PINBALL_PACK] = {
            mission: Mission.TYPE_PINBALL,
            product: "kit3",
            view: SingleProductOfferWindow,
            reward: RewardsConfig.PinballPack,
            sideBarJson: bundles.sidebar.jsons.pinball_offer_json,
            name: "PinballOffer",
            bundle: "pinball_offer"
        };
    }

    if (cleverapps.config.name === "woodenblock") {
        Offers[Offers.TYPES.BOOSTER_OFFER] = {
            sideBarJson: bundles.sidebar.jsons.booster_offer_icon_json,
            name: "BoosterOffer",
            bundle: "booster_offer",
            product: "kit3",
            reward: RewardsConfig.BoosterOffer,
            logic: BoosterOfferLogic,
            view: BoosterOfferWindow
        };
    }

    if (cleverapps.config.features.includes("offers") && cleverapps.config.type === "merge2") {
        Offers[Offers.TYPES.TSEARCHPACK] = {
            mission: Mission.TYPE_TREASURE_SEARCH,
            sideBarJson: bundles.sidebar.jsons.tsearch_pack_json,
            productByPayerLevel: ["kit3", "kit3", "kit5", "kit5", "kit10"],
            name: "TSearchPack",
            duration: "4 days",
            oncePerMission: true,
            view: OfferWindow,
            bundle: "offer_0",
            rewardByPayerLevel: RewardsConfig.TSearchPack,
            pendingWindow: true
        };

        Offers[Offers.TYPES.SPACERACEPACK] = {
            mission: Mission.TYPE_SPACE_RACE,
            sideBarJson: bundles.sidebar.jsons.spacerace_pack_json,
            productByPayerLevel: ["kit1", "kit1", "kit3", "kit3", "kit5"],
            name: "SpaceRacePack",
            duration: "3 days",
            oncePerMission: true,
            view: OfferWindow,
            bundle: "offer_1",
            rewardByPayerLevel: RewardsConfig.SpaceRacePack,
            pendingWindow: true
        };
  
        Offers[Offers.TYPES.NEW_STARTER_PACK] = {
            sideBarJson: bundles.sidebar.jsons.new_starter_pack_json,
            product: "kit5",
            name: "NewStarterPack",
            duration: "2 days",
            once: true,
            view: OfferWindow,
            bundle: "offer_2",
            reward: RewardsConfig.NewStarterPack,
            available: cleverapps.config.availables.NEW_STARTER_PACK,
            pendingWindow: true
        };

        Offers[Offers.TYPES.GENERATOR_OFFER_AB] = {
            sideBarJson: bundles.sidebar.jsons.generator_pack_json,
            productByPayerLevel: ["kit3", "kit3", "kit5", "kit5", "kit10"],
            name: "GeneratorOfferAB",
            shopIcon: "generatoroffer",
            duration: "1 hour",
            cooldown: "1 day",
            view: OfferWindow,
            bundle: "offer_3",
            afterEvent: "SPAWN_AFTER_MERGE_AB_5",
            rewardByPayerLevel: RewardsConfig.GeneratorOffer_AB,
            available: cleverapps.config.availables.GENERATOR_OFFER,
            pendingWindow: true,
            oneOf: [Offers.TYPES.GENERATOR_OFFER_AB, Offers.TYPES.GENERATOR_OFFER_CD, Offers.TYPES.GENERATOR_OFFER_E, Offers.TYPES.GENERATOR_OFFER_Z,
                Offers.TYPES.GENERATOR_OFFER_F, Offers.TYPES.GENERATOR_OFFER_GH, Offers.TYPES.GENERATOR_OFFER_I, Offers.TYPES.GENERATOR_OFFER_O]
        };

        Offers[Offers.TYPES.GENERATOR_OFFER_CD] = {
            sideBarJson: bundles.sidebar.jsons.generator_pack_json,
            productByPayerLevel: ["kit3", "kit3", "kit5", "kit5", "kit10"],
            name: "GeneratorOfferCD",
            shopIcon: "generatoroffer",
            duration: "1 hour",
            cooldown: "1 day",
            view: OfferWindow,
            bundle: "offer_3",
            afterEvent: "SPAWN_AFTER_MERGE_CD_5",
            rewardByPayerLevel: RewardsConfig.GeneratorOffer_CD,
            available: cleverapps.config.availables.GENERATOR_OFFER,
            pendingWindow: true,
            oneOf: [Offers.TYPES.GENERATOR_OFFER_AB, Offers.TYPES.GENERATOR_OFFER_CD, Offers.TYPES.GENERATOR_OFFER_E, Offers.TYPES.GENERATOR_OFFER_Z,
                Offers.TYPES.GENERATOR_OFFER_F, Offers.TYPES.GENERATOR_OFFER_GH, Offers.TYPES.GENERATOR_OFFER_I, Offers.TYPES.GENERATOR_OFFER_O]
        };

        Offers[Offers.TYPES.GENERATOR_OFFER_E] = {
            sideBarJson: bundles.sidebar.jsons.generator_pack_json,
            productByPayerLevel: ["kit3", "kit3", "kit5", "kit5", "kit10"],
            name: "GeneratorOfferE",
            shopIcon: "generatoroffer",
            duration: "1 hour",
            cooldown: "1 day",
            view: OfferWindow,
            bundle: "offer_3",
            afterEvent: "SPAWN_AFTER_MERGE_E_5",
            rewardByPayerLevel: RewardsConfig.GeneratorOffer_E,
            available: cleverapps.config.availables.GENERATOR_OFFER,
            pendingWindow: true,
            oneOf: [Offers.TYPES.GENERATOR_OFFER_AB, Offers.TYPES.GENERATOR_OFFER_CD, Offers.TYPES.GENERATOR_OFFER_E, Offers.TYPES.GENERATOR_OFFER_Z,
                Offers.TYPES.GENERATOR_OFFER_F, Offers.TYPES.GENERATOR_OFFER_GH, Offers.TYPES.GENERATOR_OFFER_I, Offers.TYPES.GENERATOR_OFFER_O]
        };

        Offers[Offers.TYPES.GENERATOR_OFFER_Z] = {
            sideBarJson: bundles.sidebar.jsons.generator_pack_json,
            productByPayerLevel: ["kit3", "kit3", "kit5", "kit5", "kit10"],
            name: "GeneratorOfferZ",
            shopIcon: "generatoroffer",
            duration: "1 hour",
            cooldown: "1 day",
            view: OfferWindow,
            bundle: "offer_3",
            afterEvent: "SPAWN_AFTER_MERGE_Z_5",
            rewardByPayerLevel: RewardsConfig.GeneratorOffer_Z,
            available: cleverapps.config.availables.GENERATOR_OFFER,
            pendingWindow: true,
            oneOf: [Offers.TYPES.GENERATOR_OFFER_AB, Offers.TYPES.GENERATOR_OFFER_CD, Offers.TYPES.GENERATOR_OFFER_E, Offers.TYPES.GENERATOR_OFFER_Z,
                Offers.TYPES.GENERATOR_OFFER_F, Offers.TYPES.GENERATOR_OFFER_GH, Offers.TYPES.GENERATOR_OFFER_I, Offers.TYPES.GENERATOR_OFFER_O]
        };

        Offers[Offers.TYPES.GENERATOR_OFFER_F] = {
            sideBarJson: bundles.sidebar.jsons.generator_pack_json,
            productByPayerLevel: ["kit3", "kit3", "kit5", "kit5", "kit10"],
            name: "GeneratorOfferF",
            shopIcon: "generatoroffer",
            duration: "1 hour",
            cooldown: "1 day",
            view: OfferWindow,
            bundle: "offer_3",
            afterEvent: "SPAWN_AFTER_MERGE_F_5",
            rewardByPayerLevel: RewardsConfig.GeneratorOffer_F,
            available: cleverapps.config.availables.GENERATOR_OFFER,
            pendingWindow: true,
            oneOf: [Offers.TYPES.GENERATOR_OFFER_AB, Offers.TYPES.GENERATOR_OFFER_CD, Offers.TYPES.GENERATOR_OFFER_E, Offers.TYPES.GENERATOR_OFFER_Z,
                Offers.TYPES.GENERATOR_OFFER_F, Offers.TYPES.GENERATOR_OFFER_GH, Offers.TYPES.GENERATOR_OFFER_I, Offers.TYPES.GENERATOR_OFFER_O]
        };

        Offers[Offers.TYPES.GENERATOR_OFFER_GH] = {
            sideBarJson: bundles.sidebar.jsons.generator_pack_json,
            productByPayerLevel: ["kit3", "kit3", "kit5", "kit5", "kit10"],
            name: "GeneratorOfferGH",
            shopIcon: "generatoroffer",
            duration: "1 hour",
            cooldown: "1 day",
            view: OfferWindow,
            bundle: "offer_3",
            afterEvent: "SPAWN_AFTER_MERGE_GH_5",
            rewardByPayerLevel: RewardsConfig.GeneratorOffer_GH,
            available: cleverapps.config.availables.GENERATOR_OFFER,
            pendingWindow: true,
            oneOf: [Offers.TYPES.GENERATOR_OFFER_AB, Offers.TYPES.GENERATOR_OFFER_CD, Offers.TYPES.GENERATOR_OFFER_E, Offers.TYPES.GENERATOR_OFFER_Z,
                Offers.TYPES.GENERATOR_OFFER_F, Offers.TYPES.GENERATOR_OFFER_GH, Offers.TYPES.GENERATOR_OFFER_I, Offers.TYPES.GENERATOR_OFFER_O]
        };

        Offers[Offers.TYPES.GENERATOR_OFFER_I] = {
            sideBarJson: bundles.sidebar.jsons.generator_pack_json,
            productByPayerLevel: ["kit3", "kit3", "kit5", "kit5", "kit10"],
            name: "GeneratorOfferI",
            shopIcon: "generatoroffer",
            duration: "1 hour",
            cooldown: "1 day",
            view: OfferWindow,
            bundle: "offer_3",
            afterEvent: "SPAWN_AFTER_MERGE_I_5",
            rewardByPayerLevel: RewardsConfig.GeneratorOffer_I,
            available: cleverapps.config.availables.GENERATOR_OFFER,
            pendingWindow: true,
            oneOf: [Offers.TYPES.GENERATOR_OFFER_AB, Offers.TYPES.GENERATOR_OFFER_CD, Offers.TYPES.GENERATOR_OFFER_E, Offers.TYPES.GENERATOR_OFFER_Z,
                Offers.TYPES.GENERATOR_OFFER_F, Offers.TYPES.GENERATOR_OFFER_GH, Offers.TYPES.GENERATOR_OFFER_I, Offers.TYPES.GENERATOR_OFFER_O]
        };

        Offers[Offers.TYPES.GENERATOR_OFFER_O] = {
            sideBarJson: bundles.sidebar.jsons.generator_pack_json,
            productByPayerLevel: ["kit3", "kit3", "kit5", "kit5", "kit10"],
            name: "GeneratorOfferO",
            shopIcon: "generatoroffer",
            duration: "1 hour",
            cooldown: "1 day",
            view: OfferWindow,
            bundle: "offer_3",
            afterEvent: "SPAWN_AFTER_MERGE_O_5",
            rewardByPayerLevel: RewardsConfig.GeneratorOffer_O,
            available: cleverapps.config.availables.GENERATOR_OFFER,
            pendingWindow: true,
            oneOf: [Offers.TYPES.GENERATOR_OFFER_AB, Offers.TYPES.GENERATOR_OFFER_CD, Offers.TYPES.GENERATOR_OFFER_E, Offers.TYPES.GENERATOR_OFFER_Z,
                Offers.TYPES.GENERATOR_OFFER_F, Offers.TYPES.GENERATOR_OFFER_GH, Offers.TYPES.GENERATOR_OFFER_I, Offers.TYPES.GENERATOR_OFFER_O]
        };

        Offers[Offers.TYPES.HIGH_STAGE_A] = {
            sideBarJson: bundles.sidebar.jsons.highstage_pack_json,
            productByPayerLevel: ["kit1", "kit3", "kit5", "kit10", "kit20"],
            name: "HighStageA",
            shopIcon: "highstage",
            duration: "1 hour",
            cooldown: "1 day",
            view: OfferWindow,
            bundle: "offer_4",
            afterEvent: "SPAWN_AFTER_MERGE_a_10",
            rewardByPayerLevel: RewardsConfig.HighStageA,
            available: cleverapps.config.availables.HIGH_STAGE,
            pendingWindow: true,
            oneOf: [Offers.TYPES.HIGH_STAGE_A, Offers.TYPES.HIGH_STAGE_C, Offers.TYPES.HIGH_STAGE_E, Offers.TYPES.HIGH_STAGE_G, Offers.TYPES.HIGH_STAGE_I]
        };

        Offers[Offers.TYPES.HIGH_STAGE_C] = {
            sideBarJson: bundles.sidebar.jsons.highstage_pack_json,
            productByPayerLevel: ["kit1", "kit3", "kit5", "kit10", "kit20"],
            name: "HighStageC",
            shopIcon: "highstage",
            duration: "1 hour",
            cooldown: "1 day",
            view: OfferWindow,
            bundle: "offer_4",
            afterEvent: "SPAWN_AFTER_MERGE_c_10",
            rewardByPayerLevel: RewardsConfig.HighStageC,
            available: cleverapps.config.availables.HIGH_STAGE,
            pendingWindow: true,
            oneOf: [Offers.TYPES.HIGH_STAGE_A, Offers.TYPES.HIGH_STAGE_C, Offers.TYPES.HIGH_STAGE_E, Offers.TYPES.HIGH_STAGE_G, Offers.TYPES.HIGH_STAGE_I]
        };

        Offers[Offers.TYPES.HIGH_STAGE_E] = {
            sideBarJson: bundles.sidebar.jsons.highstage_pack_json,
            productByPayerLevel: ["kit1", "kit3", "kit5", "kit10", "kit20"],
            name: "HighStageE",
            shopIcon: "highstage",
            duration: "1 hour",
            cooldown: "1 day",
            view: OfferWindow,
            bundle: "offer_4",
            afterEvent: "SPAWN_AFTER_MERGE_e_5",
            rewardByPayerLevel: RewardsConfig.HighStageE,
            available: cleverapps.config.availables.HIGH_STAGE,
            pendingWindow: true,
            oneOf: [Offers.TYPES.HIGH_STAGE_A, Offers.TYPES.HIGH_STAGE_C, Offers.TYPES.HIGH_STAGE_E, Offers.TYPES.HIGH_STAGE_G, Offers.TYPES.HIGH_STAGE_I]
        };

        Offers[Offers.TYPES.HIGH_STAGE_G] = {
            sideBarJson: bundles.sidebar.jsons.highstage_pack_json,
            productByPayerLevel: ["kit1", "kit3", "kit5", "kit10", "kit20"],
            name: "HighStageG",
            shopIcon: "highstage",
            duration: "1 hour",
            cooldown: "1 day",
            view: OfferWindow,
            bundle: "offer_4",
            afterEvent: "SPAWN_AFTER_MERGE_g_9",
            rewardByPayerLevel: RewardsConfig.HighStageG,
            available: cleverapps.config.availables.HIGH_STAGE,
            pendingWindow: true,
            oneOf: [Offers.TYPES.HIGH_STAGE_A, Offers.TYPES.HIGH_STAGE_C, Offers.TYPES.HIGH_STAGE_E, Offers.TYPES.HIGH_STAGE_G, Offers.TYPES.HIGH_STAGE_I]
        };

        Offers[Offers.TYPES.HIGH_STAGE_I] = {
            sideBarJson: bundles.sidebar.jsons.highstage_pack_json,
            productByPayerLevel: ["kit1", "kit3", "kit5", "kit10", "kit20"],
            name: "HighStageI",
            shopIcon: "highstage",
            duration: "1 hour",
            cooldown: "1 day",
            view: OfferWindow,
            bundle: "offer_4",
            afterEvent: "SPAWN_AFTER_MERGE_i_7",
            rewardByPayerLevel: RewardsConfig.HighStageI,
            available: cleverapps.config.availables.HIGH_STAGE,
            pendingWindow: true,
            oneOf: [Offers.TYPES.HIGH_STAGE_A, Offers.TYPES.HIGH_STAGE_C, Offers.TYPES.HIGH_STAGE_E, Offers.TYPES.HIGH_STAGE_G, Offers.TYPES.HIGH_STAGE_I]
        };

        Offers.defineSeasonal(["kit1", "kit3", "kit5", "kit10", "kit20"], (feature) => bundles.sidebar.jsons[`${feature}_json`] && {
            sideBarJson: bundles.sidebar.jsons[`${feature}_json`]
        });
    }

    if (cleverapps.config.name === "garden") {
        Offers[Offers.TYPES.LEVEL_MASTERY_PACK] = {
            mission: Mission.TYPE_LEVEL_MASTERY,
            sideBarJson: bundles.sidebar.jsons.level_mastery_pack_json,
            productByPayerLevel: ["kit1", "kit3", "kit5", "kit10", "kit20"],
            name: "LevelMasteryPack",
            duration: "4 days",
            oncePerMission: true,
            view: OfferWindow,
            bundle: "offer_6",
            rewardByPayerLevel: RewardsConfig.LevelMasteryPack,
            pendingWindow: true
        };

        Offers[Offers.TYPES.LIGHTNING_RUSH_PACK] = {
            mission: Mission.TYPE_LIGHTNING_RUSH,
            sideBarJson: bundles.sidebar.jsons.lightning_rush_pack_json,
            productByPayerLevel: ["kit1", "kit3", "kit5", "kit10", "kit20"],
            name: "LightningRushPack",
            duration: "5 days",
            oncePerMission: true,
            view: OfferWindow,
            bundle: "offer_7",
            rewardByPayerLevel: RewardsConfig.LightningRushPack,
            pendingWindow: true
        };

        Offers[Offers.TYPES.LORIES_DERBY_PACK] = {
            mission: Mission.TYPE_LORYS_DERBY,
            sideBarJson: bundles.sidebar.jsons.lories_derby_pack_json,
            productByPayerLevel: ["kit1", "kit3", "kit5", "kit10", "kit20"],
            name: "LoriesDerbyPack",
            duration: "4 days",
            oncePerMission: true,
            view: OfferWindow,
            bundle: "offer_8",
            rewardByPayerLevel: RewardsConfig.LoriesDerbyPack,
            pendingWindow: true
        };
    }

    Offers.offersByLocation = {};
    Offers.offerByMission = {};
    Offers.noMissionOffer = {};
    Offers.offerByHero = {};
    Offers.offersByFog = {};
    Offers.offersByEvent = {};

    for (const name in Offers.TYPES) {
        const type = Offers.TYPES[name];
        const offer = Offers[type];

        if (offer) {
            offer.type = type;

            if (offer.location) {
                if (!Offers.offersByLocation[offer.location]) {
                    Offers.offersByLocation[offer.location] = [];
                }

                Offers.offersByLocation[offer.location].push(offer);
            }

            if (offer.mission) {
                Offers.offerByMission[offer.mission] = offer;
            } else {
                Offers.noMissionOffer[offer.name] = offer;
            }

            if (offer.hero) {
                Offers.offerByHero[Unit.GetKey(offer.hero)] = offer;
            }

            if (offer.fog) {
                if (Offers.offersByFog[offer.fog]) {
                    Offers.offersByFog[offer.fog].push(offer);
                } else {
                    Offers.offersByFog[offer.fog] = [offer];
                }
            }

            if (offer.afterEvent) {
                cleverapps.toArray(offer.afterEvent).forEach((afterEvent) => {
                    if (Offers.offersByEvent[afterEvent]) {
                        Offers.offersByEvent[afterEvent].push(offer);
                    } else {
                        Offers.offersByEvent[afterEvent] = [offer];
                    }
                });
            }
        }
    }
};

if (typeof cc === "undefined") {
    module.exports = Offers;
}
